<template>
  <div class="region-placeholder text-center">
    <v-icon size="56" color="#b0bec5" class="mb-3">{{ icon }}</v-icon>
    <div class="subtitle-1 font-weight-medium mb-2">{{ title }}</div>
    <p class="region-placeholder__text mb-0">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'RegionSectionPlaceholder',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'mdi-information-outline',
    },
  },
};
</script>

<style lang="scss" scoped>
.region-placeholder__text {
  max-width: 520px;
  margin: 0 auto;
  color: #78909c;
  line-height: 1.5;
}
</style>
